const userAgent = navigator.userAgent
const os = userAgent.includes('Android') ? 'Android' : 'iPhone'

const sensor = {
  // web点击事件
  async appWebClick(params) {
    let accountId
    try {
      const user = await window.__oneLiteBridge.mHandshake()
      accountId = user.id
    } catch (error) {
     console.log(error) 
    }
    const config = {
      $os: os,
      appName: '布谷妈妈',
      account_id: accountId,
      app_url: location.href,
      ...params
    }
    console.log(JSON.stringify(config))
    sensors.track('APP_web_click', config)
  }
}

export default sensor